import 'shared/global';
import 'components/subnav';
import { formatTimeElements } from 'helpers/dates';
import SeasonDropdownFilter from 'components/dropdownFilters/DropdownFilter';

$(document).ready(function () {
    let parentContainer = $('#main-container');
    let filters = null;
    let season = parentContainer.data('season');

    // FILTERS
    if (parentContainer.find('.js-dropdown').length > 0) {
        filters = new SeasonDropdownFilter();
        filters.setMount(parentContainer.find('.js-dropdown')).build();

        season = filters.options[filters.selectedInd].value;

        $(filters).on('filterSelected', (e, index, value) => {
            var origin = window.location.origin;
            var pathName = window.location.pathname;

            if (pathName.includes('/episodes/')) {
                const [pathNameRoot, episodePart] = pathName.split('episodes/');
                pathName = pathNameRoot;
            }
            var pageUrl = origin + pathName + 'episodes/' + value + '/';
            location.href = pageUrl;
        });
    }

    formatTimeElements();
});
